(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["device-compatibility-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  const openBtn = document.querySelector(".btn-popup_content");
  const modal = document.getElementById("modal-dev-comp");
  const closeBtns = modal.querySelectorAll(".js-dialog-close-btn");

  if (!openBtn || !modal) return;

  function openModal() {
    modal.toggleAttribute("hidden", !1),
    modal.classList.add("is-active");
  }

  function closeModal() {
    modal.hidden = true;
    modal.classList.remove("no-focus-visible");
  }

  // Open modal
  openBtn.addEventListener("click", openModal);

  // Close buttons
  closeBtns.forEach(btn => {
    btn.addEventListener("click", closeModal);
  });

  // Click outside dialog closes modal
  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // ESC key closes modal
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !modal.hidden) {
      closeModal();
    }
  });
});



     // Search Bar
document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("modelSearches");
  const resultList = document.getElementById("searchResult");

  let models = [];

  const jsonURL = "https://cdn.shopify.com/s/files/1/0944/9485/1412/files/models_corrected.json?v=1783936611";

  // Load models
  fetch(jsonURL)
    .then((res) => res.json())
    .then((data) => {
      models = data; // array of objects like { name, compatible, category }
    });

  input.addEventListener("input", () => {
    const query = input.value.toLowerCase();
    resultList.innerHTML = "";

    if (query.length === 0) {
      resultList.style.display = "none";
      return;
    }

    const filtered = models.filter((model) =>
      model.name.toLowerCase().includes(query)
    );

    if (filtered.length === 0) {
      resultList.innerHTML = "<li>No results found</li>";
      resultList.style.display = "block";
      return;
    }

    const grouped = filtered.reduce((acc, model) => {
      const category = model.category || "Other";
      if (!acc[category]) acc[category] = [];
      acc[category].push(model);
      return acc;
    }, {});

    Object.entries(grouped).forEach(([category, items]) => {
      const categoryHeader = document.createElement("li");
      categoryHeader.innerHTML = `<strong>${category}</strong>`;
      categoryHeader.style.marginTop = "10px";
      resultList.appendChild(categoryHeader);

      items.forEach((model) => {
        const li = document.createElement("li");
        li.innerHTML = `${model.name} — <strong style="color: ${model.compatible ? 'green' : 'red'}">${model.compatible ? 'Compatible' : 'Not Compatible'}</strong>`;
        resultList.appendChild(li);
      });
    });

    resultList.style.display = "block";
  });

  // ✅ Fix: This part must be INSIDE the DOMContentLoaded callback
  document.addEventListener("click", (e) => {
    if (!input.contains(e.target) && !resultList.contains(e.target)) {
      resultList.style.display = "none";
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
